/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-04 15:57:05
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-07-06 23:26:47
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\setTemplate\api\index.js
 */
import req from '@/utils/req.js'


//获取模板消息列表 
export function publicList(params) {
    return req.get('/dsicm-contact-platform/feign/wechat-public-template/list',params)
}

//删除公众号模板消息 
export function delpublic(params) {
    return req.delete(`/dsicm-contact-platform/feign/wechat-public-template/delete?publicId=${params.publicId}&templateId=${params.templateId}`)
}


//获取公众号标签列表
export function getLabelList(params) {
    return req.get('/dsicm-contact-platform/feign/wechat-public-template/getLabelList',params)
}

//发送模板
export function webSendTemplate(params) {
    return req.post('/dsicm-contact-platform/feign/wechat-public-template/newWebSend',params)
}

//获取公众号下用户接口
export function getWechatUser(params) {
    return req.get('/dsicm-contact-platform/wechat-public-user/page/subscribe',params)
}

//获取发送记录列表
export function getSendRecordPage(params) {
    return req.post('/dsicm-contact-platform/feign/template-message-send-record/page',params)
}


//发送记录详情用户列表
export function getDeliveryResult(params) {
    return req.post('/dsicm-contact-platform/feign/template-message-delivery-result/page',params)
}

//模板消息推送任务详情
export function getTemplateDetail(params) {
    return req.get(`/dsicm-contact-platform/feign/template-message-send-record/${params}`)
}

